import { Directive, Input, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[InputFloatNumber]'
})
export class InputFloatNumberDirective {

    constructor(private el: ElementRef) { }

    @Input() InputFloatNumber: boolean;

//188 ,
//190 .
//110 NumpadDecimal

    @HostListener('keydown', ['$event']) onKeyDown(event) {
        let e = <KeyboardEvent> event;
        if (this.InputFloatNumber) {
            //190: dot, removed from array in row bellow
            if ([46, 8, 9, 27, 13, 110,188,190].indexOf(e.keyCode) !== -1 ||
                // Allow: Ctrl+A
                (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
                // Allow: Ctrl+C
                (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
                // Allow: Ctrl+V
                (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
                // Allow: Ctrl+X
                // Allow: home, end, left, right
                (e.keyCode >= 35 && e.keyCode <= 39)) {
                // let it happen, don't do anything
                    return;
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        }
    }

    @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
            event.preventDefault();
            const pastedInput: string = event.clipboardData
            .getData('text/plain')
            .replace(/[^\d.-]+/g, ''); // get a digit-only string and .
            document.execCommand('insertText', false, pastedInput);
    }

}


